import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Invitation.css';

const Invitation = () => {
  const sections = useRef([]);
  const navigate = useNavigate();
  const [isInterviewModalOpen, setIsInterviewModalOpen] = useState(false);
  const [showAllPhotos, setShowAllPhotos] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.current.forEach(section => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sections.current.forEach(section => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const [loadedImages, setLoadedImages] = useState(new Set());

  const galleryPhotos = [
    "./assets/couple8.jpeg",
    "./assets/couple1.jpeg",
    "./assets/couple2.jpeg",
    "./assets/couple9.jpeg",
    "./assets/couple3.jpeg",
    "./assets/couple6.jpeg",
    "./assets/couple7.jpeg",
    "./assets/couple4.jpeg",
  ];

  const handleImageLoad = (index) => {
    setLoadedImages(prev => new Set([...prev, index]));
  };

  const interviewData = [
    {
      question: "결혼을 결심한 이유는?",
      groomAnswer: `함께하면서 제가 더 나아짐을 배웠고, 그 곁에서 본모습으로 있을 수 있어 평생을 함께하기로 마음먹었습니다. ( 미소가 아름다워요  😁 )`,
      brideAnswer: `만34세, 90년생 말띠. 더 이상 시간을 낭비할 여유가 없어 정말 신중하게 평생의 짝궁을 찾았습니다.`
    },
    {
      question: "결혼을 앞둔 소감?",
      groomAnswer: `무덤덤 합니다. 하지만 함께해주는 짝궁과 함께라면 힘내서 진행하고 행복하게 마무리 할 수 있을것 같아요.`,
      brideAnswer: `결혼하신 선배님들이 항상 결혼은 현실이고, 해봐야 안다고 하셨는데, 지금 그 현실을 하나하나 경험하고 있는 중입니다.
준비 과정이 쉽지 않은 것은 모두가 공감하는 부분인 것 같아요,
하지만 이제 결혼식이 코앞에 다가왔다고 생각하니, 모든 수고로움이 설렘으로 바뀌고 벅차고 좋고 신기합니다.
저희를 있게 해주신 부모님들께 감사드리고, 이 소중한 시작을 축복해 주실 모든 분들께 감사한 마음으로 잘살겠습니다.`
    },
    {
      question: "서로에게 하고 싶은 말은?",
      groomAnswer: `항상 양보하고 자신감을 북돋아줘서 감사해요.`,
      brideAnswer: `사랑해`,
    },
    {
      question: "가족혼을 선택하게 된 이유는?",
      groomAnswer: `가족들과 편안하고 의미 있는 시간이 가장 저희답게 시작할 수 있을것 같아 소박하게 진행하기로 결정했습니다`,
    }
  ];

  return (
    <>
      <div className="initial-card-container">
        <div className="card main-card" ref={el => sections.current[0] = el}>
          <p className="quote">우리 두사람 이야기에 <br/>영감을 준 영화처럼</p>
          <div className="divider"></div>
          <p className="quote">사랑에 유통기한을 정해야 한다면,</p>
          <p className="quote">만 년으로 하고 싶다.</p>
          <p className="quote-left">- 영화 '중경삼림' -</p>
          <img src="/assets/can.png" width={100} height={100} alt="message-icon" />
          <div className="divider"></div>
        </div>
        <div className="scroll-indicator">
          <span>SCROLL</span>
          <div className="chevron"></div>
          <div className="chevron"></div>
        </div>
      </div>
      <div className="chungking-theme">
        <div className="card location-section" ref={el => sections.current[1] = el}>
          <div className="divider"></div>
          <h2>김진한 · 김수경</h2>
          <p className="date">2025년 12월 13일</p>
          <div className="divider"></div>
          <p className="invitation-message">

저희 두 사람이 하나 되어<br/>
가정을 이루게 되었습니다.
          </p>
<p className="invitation-message">

죄송하게도 양가 가족들만 모시고<br/> 간소하게 식을 올리게 되었습니다.


          </p>
          <p className="invitation-message">


넓은 마음으로 <br/>축복 부탁드리겠습니다.

          </p>
          <p className="invitation-message">


마음으로 축복해 주시는 만큼,<br/>
행복한 모습으로 보답하겠습니다.
          </p>
          <p className="invitation-message">부부 올림</p>        
        </div>

        <div className="card gallery-section" ref={el => sections.current[2] = el}>
          <h2>GALLERY</h2>
          <p className="gallery-subtitle">웨딩 갤러리</p>

          {/* 항상 보이는 비대칭 레이아웃 (처음 4개) */}
          <div className="gallery-wrapper">
            <div className="gallery-grid-asymmetric">
              {galleryPhotos.slice(0, 4).map((photo, index) => (
                <div key={index} className={`gallery-item gallery-item-${index + 1}`}>
                  {!loadedImages.has(index) && <div className="image-skeleton"></div>}
                  <img
                    src={photo}
                    alt={`커플 사진 ${index + 1}`}
                    loading="eager"
                    onLoad={() => handleImageLoad(index)}
                    style={{ opacity: loadedImages.has(index) ? 1 : 0 }}
                  />
                </div>
              ))}
            </div>
            {!showAllPhotos && galleryPhotos.length > 4 && <div className="gallery-fade-overlay"></div>}
          </div>

          {/* 더보기 클릭 시 보이는 2열 그리드 (나머지 사진들) */}
          {showAllPhotos && galleryPhotos.length > 4 && (
            <div className="gallery-grid-regular">
              {galleryPhotos.slice(4).map((photo, index) => {
                const imageIndex = index + 4;
                return (
                  <div key={imageIndex} className="gallery-item">
                    {!loadedImages.has(imageIndex) && <div className="image-skeleton"></div>}
                    <img
                      src={photo}
                      alt={`커플 사진 ${imageIndex + 1}`}
                      loading="lazy"
                      onLoad={() => handleImageLoad(imageIndex)}
                      style={{ opacity: loadedImages.has(imageIndex) ? 1 : 0 }}
                    />
                  </div>
                );
              })}
            </div>
          )}

          <div className="gallery-more-wrapper">
            {galleryPhotos.length > 4 && (
              <button
                className="gallery-more-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAllPhotos(!showAllPhotos);
                }}
              >
                {showAllPhotos ? '접기 ⌃' : '더보기 ⌄'}
              </button>
            )}
          </div>
        </div>

        <div className="card location-section" ref={el => sections.current[3] = el}>
          <h2>혼인 장소</h2>
          <p className="venue">Lotte Hotel Seoul</p>
          <p className="address">서울 중구 을지로 30</p>
          <p><a href="https://naver.me/FqWt5LwL" target="_blank" rel="noopener noreferrer" className="map-button">지도보기</a></p>
        </div>

        <div className="card contact-section" ref={el => sections.current[4] = el}>
          <h2>연락처</h2>
          <p>신랑 김진한: <a href="tel:010-4178-0430">010-4178-0430</a></p>
          <p>신부 김수경: <a href="tel:010-4441-5735">010-4441-5735</a></p>
        </div>

        {/* 신랑신부 인터뷰 섹션 */}
        <div
          className="card guestbook-section"
          ref={el => sections.current[5] = el}
          onClick={() => setIsInterviewModalOpen(true)}
        >
          <div className="interview-icon">💬</div>
          <h3>신랑신부 결혼 인터뷰</h3>
          <p>두 사람의 솔직한 이야기</p>
          <div className="click-hint">
            <span>클릭하여 인터뷰 보기</span>
            <div className="arrow-container">
              <span className="arrow">→</span>
              <span className="arrow">→</span>
              <span className="arrow">→</span>
            </div>
          </div>

          <div className="floating-cta">
            <div className="cta-button">
              <span>인터뷰 읽어보기</span>
              <div className="button-glow"></div>
            </div>
          </div>
        </div>

        <div
          className="card guestbook-section"
          ref={el => sections.current[6] = el}
          onClick={() => navigate('/guestbook')}
        >
          <div className="guestbook-icon">💖</div>
          <h3>당신의 한마디를 남겨주세요</h3>
          <p>소중한 분들의 축복이 우리의 행복이 됩니다</p>
          <div className="click-hint">
            <span>클릭하여 방명록 보기</span>
            <div className="arrow-container">
              <span className="arrow">→</span>
              <span className="arrow">→</span>
              <span className="arrow">→</span>
            </div>
          </div>
          
          <div className="floating-cta">
            <div className="cta-button">
              <span>방명록에 축복 남기기</span>
              <div className="button-glow"></div>
            </div>
          </div>
        </div>
      </div>

      {/* 인터뷰 모달 */}
      {isInterviewModalOpen && (
        <div className="modal-overlay" onClick={() => setIsInterviewModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setIsInterviewModalOpen(false)}>×</button>

            <div className="modal-header">
              <div className="modal-subtitle">INTERVIEW</div>
              <h2 className="modal-title">우리 두 사람의 이야기</h2>
            </div>

            <div className="interview-container">
              {interviewData.map((item, index) => (
                <div key={index} className="interview-item">
                  <div className="interview-question">Q{index + 1}. {item.question}</div>

                  <div className="interview-answer">
                    {item.brideAnswer ?  
                      <div className="answer-author">💍 신랑 진한</div>:<div className="answer-author">💍 신랑 진한 💐 신부 수경</div>
                    }
                    <p className="answer-text">{item.groomAnswer}</p>
                  </div>

                  <div className="interview-answer">
                    {item.brideAnswer ?  <div className="interview-answer">
                      <div className="answer-author">💐 신부 수경</div>
                      <p className="answer-text">{item.brideAnswer}</p>
                    </div>: 
                    ''
                    }
                    
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Invitation;
